import React from 'react';
import { Menu } from '@mui/material';

type Props = {
  children: React.JSX.Element;
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
};

const MenuPopOver = (props: Props) => {
  const { children, anchorEl, onClose, open } = props;

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      transformOrigin={{ horizontal: 'center', vertical: 'top' }}
      slotProps={{
        paper: {
          sx: {
            width: '28rem',
            border: 'none',
            backgroundColor: 'transparent',
            margin: '0.5rem 0',
            padding: 0,
            borderRadius: 2,
            '& .MuiList-root': {
              padding: 0,
            },
          },
        },
      }}
    >
      {children}
    </Menu>
  );
};
export default MenuPopOver;
